import VueRouter from 'vue-router'

const routes = [
  {
    path: '/',
    component: require('@/views/global/frame/frame.component.vue'),
    children: [
      {
        name: 'HomePage',
        path: '/',
        component: require('@/views/pages/homepage/homepage.component.vue')
      },
      /*
      {
        name: 'StaffPage',
        path: '/equipe',
        component: require('@/views/pages/staff/staff.component.vue')
      },
      { path: '/%C3%A9quipe', redirect: '/equipe' },
      { path: '/l-equipe', redirect: '/equipe' },
      { path: '/l-%C3%A9quipe', redirect: '/equipe' },
      */
      {
        name: 'CabinetPage',
        path: '/cabinet',
        component: require('@/views/pages/cabinet/cabinet.component.vue')
      },
      {
        name: 'EngagementPage',
        path: '/engagement',
        component: require('@/views/pages/engagement/engagement.component.vue')
      },
      {
        name: 'AccessPage',
        path: '/acces',
        component: require('@/views/pages/access/access.component.vue')
      },
      { path: '/acc%C3%A8s', redirect: '/acces' },
      { path: '/access', redirect: '/acces' },
      { path: '/acc%C3%A9s', redirect: '/acces' },
      {
        name: 'ContactPage',
        path: '/contact',
        component: require('@/views/pages/contact/contact.component.vue')
      },
      {
        name: 'ExpertisePage',
        path: '/expertise',
        component: require('@/views/pages/expertise/expertise.component.vue')
      },
      {
        name: 'FAQPage',
        path: '/faq',
        component: require('@/views/pages/faq/faq.component.vue')
      },
      {
        name: 'TreatmentsPage',
        path: '/traitements-et-avis',
        component: require('@/views/pages/treatments/treatments.component.vue')
      },
      { path: '/traitements', redirect: '/traitements-et-avis' },
      { path: '/traitement', redirect: '/traitements-et-avis' },
      { path: '/avis', redirect: '/traitements-et-avis' },
      { path: '/traitements-avis', redirect: '/traitements-et-avis' },
      { path: '/traitement-avis', redirect: '/traitements-et-avis' }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js